const STORAGE_KEY = 'mc-theme'

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light'
}

export function getTheme() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === THEMES.DARK) return THEMES.DARK
  return THEMES.LIGHT
}

export function setTheme(theme) {
  const value = theme === THEMES.LIGHT ? THEMES.LIGHT : THEMES.DARK
  localStorage.setItem(STORAGE_KEY, value)
  document.documentElement.setAttribute('data-theme', value)
  window.dispatchEvent(new CustomEvent('mc-theme-change', { detail: { theme: value } }))
}

export function initTheme() {
  setTheme(getTheme())
}

export function toggleTheme() {
  const next = getTheme() === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK
  setTheme(next)
  return next
}

export function isLightTheme() {
  return getTheme() === THEMES.LIGHT
}
